/* eslint-disable @typescript-eslint/no-empty-function */
import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENV } from '@vfde-fe/ngx-lib/core';
import { of } from 'rxjs';

import { config } from '../../../config/pages-config';
import { environment } from '../../../environments/environment';
import { CoreConfigurationsLoader } from '@vfde-fe/ngx-lib/services/core-configurations-loader';

/** ConfigLoaderService */
@Injectable({
  providedIn: 'root',
})
export class ConfigLoaderService extends CoreConfigurationsLoader {
  /** errors */
  private errors: any;

  /** deWordingfile */
  public deWordingfile: any;

  /** commonErrors */
  private commonErrors: any;

  /** defaultGermanWordingfile */
  public defaultGermanWordingfile: any;

  /** constructor
   * @param { Injector } - injector
   */
  public constructor (private injector: Injector) {
    super();
  }

  /**
   * load regex configuration file
   */
  public load (): Promise<any> {

    if (!this.envIsSimplicity()) {
      const errorsConfig = new Promise((resolve) => {
        setTimeout(() => {
          const http = this.injector.get(HttpClient);
          http.get(environment.cmsWordingPath + 'error-messages.json').subscribe(response => {

            try {

              this.errors = response;

              resolve(this.errors);
            } catch (error) {

              console.warn('not valid json for error-messages.json file');

              http.get(environment.configPath + 'error-messages.json').subscribe(response => {
                this.errors = response;
                resolve(this.errors);
              });
            }
          }, ()=> {
            http.get(environment.configPath + 'error-messages.json').subscribe(response => {
              this.errors = response;
              resolve(this.errors);
            });
          });
        });
      });
      const deWording = new Promise((resolve) => {
        setTimeout(() => {

          const http = this.injector.get(HttpClient);

          http.get(environment.cmsWordingPath + 'i18n/deWording.json').subscribe(response => {

            try {

              this.defaultGermanWordingfile = response;

              resolve(this.defaultGermanWordingfile);
            } catch (error) {

              console.warn('not valid json for deWording.json file');
              resolve(null);
            }
          }, () => {
            resolve(null);
          });
        });
      });
      const getGermanWording = new Promise((resolve) => {

        deWording.then((value) => {

          if (!value) {

            setTimeout(() => {
              const http = this.injector.get(HttpClient);
              http.get(environment.configPath + 'i18n/defaultWording.json').subscribe(response => {
                this.defaultGermanWordingfile = response;
                resolve(this.defaultGermanWordingfile);
              });
            });
          } else {
            resolve(value);
          }
        });
      });

      return Promise.all([errorsConfig, getGermanWording]);
    } else {
      const errorsConfig = new Promise((resolve) => {
        setTimeout(() => {
          const http = this.injector.get(HttpClient);
          http.get(environment.configPath + 'error-messages.json').subscribe(response => {
            this.errors = response;
            resolve(this.errors);
          });
        });
      });
      const getGermanWording = new Promise((resolve) => {
            setTimeout(() => {
              const http = this.injector.get(HttpClient);
              http.get(environment.configPath + 'i18n/defaultWording.json').subscribe(response => {
                this.defaultGermanWordingfile = response;
                resolve(this.defaultGermanWordingfile);
              });
            });

      });

      return Promise.all([errorsConfig, getGermanWording]);
    }

  }

  /** loadPagesRoutes */
  public loadPagesRoutes (): object | object[] {
    return config;
  }

  /** getcommonErrorsConfig */
  public getcommonErrorsConfig () {
    return this.commonErrors;
  }

  /** getErrorsConfig */
  public getErrorsConfig () {
    return this.errors;
  }

  /** getDefaultGermanWordingFile */
  public getDefaultGermanWordingFile () {
    return of(this.defaultGermanWordingfile);
  }

  /** getDeWordingFile */
  public getDeWordingFile () {
    return of(this.defaultGermanWordingfile);
  }

  /** setCoreConfigRoute */
  public setCoreConfigRoute (): void {
    this.generalError = this.loadPagesRoutes()['generalError'].route;
    // this.unauthorized = this.loadPagesRoutes()['unauthorized'].route;
  }

  /** getTokenConfig */
  public getTokenConfig (): string {

    return '';
  }

  /**
   * getReasonsCodes
   */
    public getReasonsCodes () { }

  /**
   * check if the environment is simplicity or localhost
   * @returns boolean
   */
     public envIsSimplicity () {
      const currentHost = window.location.hostname;

      return (
        currentHost.indexOf(ENV.simplicity) > -1 || currentHost.indexOf(ENV.localhost) > -1
      );
    }
}
